import layout from '@/layout'

export default {
  path: '/shareholders',
  component: layout,
  redirect: '/shareholders/stock',
  name: 'shareholdersStock',
  meta: {
    title: 'shareholders',
    icon: 'shareholders'
  },
  children: [
    {
      path: '/shareholders/stock',
      name: 'shareholdersStock',
      component: () => import('@/views/shareholders/stock'),
      meta: {
        title: 'shareholdersStock',
        icon: 'shareholders'
      }
    }
  ]
}
